import { userHooks } from '../trpcHooks/user'

export function usePermissions() {
  const { data: user } = userHooks.useMe()

  const isOwnerOf = (customerId: number): boolean => {
    return (
      user?.customerMemberships?.find((m) => m.customerId === customerId)
        ?.role === 'owner'
    )
  }

  const getCustomerRole = (
    customerId: number,
  ): 'owner' | 'member' | undefined => {
    return user?.customerMemberships?.find((m) => m.customerId === customerId)
      ?.role
  }

  return {
    isOwnerOf,
    getCustomerRole,
    user,
  }
}
